<header mat-dialog-title>
    <div class="dialog-header">
        <h2 mat-dialog-title>Profile</h2>
        <button mat-icon-button mat-dialog-close>
            <mat-icon>close</mat-icon>
        </button>
    </div>
</header>
<mat-dialog-content class="modal-central-container">
    <div class="table mat-elevation-z2" style="padding: 16px">
        <table>
            <thead>
                <tr class="table-th-row">
                    <th *ngFor="let colName of displayedColumns" class="table-th-cell">{{colName}}</th>
                </tr>
            </thead>
            <tbody>
                <ng-container *ngFor="let filaRubrica of rubrica">
                    <ng-container *ngFor="let criterio of filaRubrica.criterios; index as y">
                        <ng-container *ngFor="let nivel of criterio.niveles; index as z">
                            <tr class="table-tr">
                                <td *ngIf="z==0" [attr.rowspan]="criterio.niveles.length" class="table-cell"
                                    style="width: 200px;">
                                    <small><b>{{filaRubrica.codigo}}-{{filaRubrica.id}}</b></small><br>
                                    {{filaRubrica.txtFR.length >
                            0 ? filaRubrica.txtFR : filaRubrica.txtEN.length > 0 ?
                            filaRubrica.txtEN : filaRubrica.txtES}}
                                </td>
                                <td *ngIf="z==0" [attr.rowspan]="criterio.niveles.length" class="table-cell">
                                    {{criterio.nombre}}
                                </td>
                                <td *ngFor="let criterioLogro of nivel.criterios" class="table-cell">
                                    {{criterioLogro.nombre}}
                                </td>
                                <td class="table-cell">
                                    <ul>
                                        <li *ngFor="let evento of criterio.eventosAprendizaje">{{evento.nombre}}</li>
                                    </ul>
                                </td>
                            </tr>
                        </ng-container>
                    </ng-container>
                </ng-container>
            </tbody>
        </table>
    </div>
</mat-dialog-content>
<mat-dialog-actions>
    <button mat-raised-button color="primary" mat-dialog-close>Cerrar</button>
</mat-dialog-actions>